import React, { useState } from 'react';
import { 
  PaperAirplaneIcon,
  PaperClipIcon,
  EyeIcon,
  XMarkIcon,
  PhotoIcon,
  DocumentIcon
} from '@heroicons/react/24/outline';

// Crown Icon Component
const CrownIcon = ({ size = 24, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" className={className} fill="currentColor">
    <path d="M5 16L3 8l2.5 2L12 4l6.5 6L21 8l-2 8H5zm2.5-7L6 8l1 4h10l1-4-1.5 1L12 7 7.5 9z"/>
  </svg>
);

// Law Enforcement Form Component
const LawEnforcementForm = ({ onClose }) => {
  const [formData, setFormData] = useState({
    zipCode: '',
    county: '',
    state: ''
  });

  const handleSubmit = () => {
    console.log('Law enforcement form submitted:', formData);
    onClose();
  };

  return (
    <div className="bg-gray-800 rounded-xl p-6 border border-gray-700">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-xl font-semibold text-white">Sheriff's Office</h3>
        <button
          onClick={onClose}
          className="text-gray-400 hover:text-white transition-colors"
        >
          <XMarkIcon className="h-6 w-6" />
        </button>
      </div>

      <div className="space-y-4">
        <div>
          <input
            type="text"
            placeholder="Zip Code"
            value={formData.zipCode}
            onChange={(e) => setFormData({ ...formData, zipCode: e.target.value })}
            className="w-full bg-gray-700 border border-gray-600 rounded-lg px-4 py-3 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent"
          />
        </div>

        <div>
          <input
            type="text"
            placeholder="County"
            value={formData.county}
            onChange={(e) => setFormData({ ...formData, county: e.target.value })}
            className="w-full bg-gray-700 border border-gray-600 rounded-lg px-4 py-3 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent"
          />
        </div>

        <div>
          <select
            value={formData.state}
            onChange={(e) => setFormData({ ...formData, state: e.target.value })}
            className="w-full bg-gray-700 border border-gray-600 rounded-lg px-4 py-3 text-white focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent"
          >
            <option value="">Select State</option>
            <option value="CA">California</option>
            <option value="TX">Texas</option>
            <option value="NY">New York</option>
            <option value="FL">Florida</option>
            <option value="IL">Illinois</option>
          </select>
        </div>

        <button
          type="button"
          onClick={handleSubmit}
          className="w-full bg-gradient-to-r from-yellow-600 to-yellow-700 hover:from-yellow-700 hover:to-yellow-800 text-black font-semibold py-3 px-4 rounded-lg transition-all duration-200"
        >
          Submit
        </button>
      </div>
    </div>
  );
};



import AdminLayoutWrapper from './common/AdminLayoutWrapper';
// Main Content Area
const MainContent = ({ children }) => {
  return (
    <AdminLayoutWrapper>
        {children}
    </AdminLayoutWrapper>
  );
};

// Enhanced Email System Component
const EnhancedEmailComponent = () => {
  const [emailType, setEmailType] = useState('rescheduling'); // 'rescheduling' or 'custom'
  const [showLawEnforcement, setShowLawEnforcement] = useState(false);
  const [attachments, setAttachments] = useState([]);
  const [emailData, setEmailData] = useState({
    salutation: 'Select Salutation',
    lastName: 'Smith',
    email: 'example@example.com',
    yourName: 'eg: Alan Doe',
    customMessage: ''
  });

  const salutationOptions = [
    'Select Salutation',
    'Mr.',
    'Mrs.',
    'Ms.',
    'Dr.',
    'Prof.'
  ];

  const handleFileAttachment = (event) => {
    const files = Array.from(event.target.files);
    const newAttachments = files.map(file => ({
      id: Date.now() + Math.random(),
      name: file.name,
      size: file.size,
      type: file.type,
      file: file
    }));
    setAttachments([...attachments, ...newAttachments]);
  };

  const removeAttachment = (id) => {
    setAttachments(attachments.filter(att => att.id !== id));
  };

  const handleSendEmail = () => {
    console.log('Sending email:', {
      type: emailType,
      data: emailData,
      attachments: attachments
    });
    // Reset form
    setEmailData({
      salutation: 'Select Salutation',
      lastName: 'Smith',
      email: 'example@example.com',
      yourName: 'eg: Alan Doe',
      customMessage: ''
    });
    setAttachments([]);
  };

  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-900 via-gray-900 to-black p-8">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <div className="flex items-center space-x-3 mb-4">
            <CrownIcon size={32} className="text-yellow-500" />
            <h1 className="text-2xl font-bold text-white">William Walker</h1>
          </div>
          
          {/* Logo/Brand Area */}
          <div className="bg-gray-800 rounded-xl p-6 border border-gray-700 mb-6">
            <div className="flex items-center justify-center">
              <div className="bg-gray-700 rounded-lg p-8 border-2 border-dashed border-gray-600">
                <div className="text-center">
                  <PhotoIcon className="mx-auto h-12 w-12 text-gray-400 mb-2" />
                  <p className="text-gray-400 text-sm">WALKTHADUCKING.COM</p>
                </div>
              </div>
            </div>
            
            <div className="flex justify-center space-x-4 mt-4">
              <input
                type="text"
                placeholder="Search"
                className="bg-gray-700 border border-gray-600 rounded-lg px-4 py-2 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-purple-500 w-48"
              />
              <button className="bg-gradient-to-r from-yellow-600 to-yellow-700 hover:from-yellow-700 hover:to-yellow-800 text-black font-semibold px-6 py-2 rounded-lg transition-all duration-200">
                Search
              </button>
            </div>

            <div className="flex justify-center space-x-4 mt-4">
              <button 
                onClick={() => setShowLawEnforcement(false)}
                className="bg-gradient-to-r from-purple-600 to-purple-700 hover:from-purple-700 hover:to-purple-800 text-white font-semibold px-6 py-2 rounded-lg transition-all duration-200"
              >
                Hide Email
              </button>
              <button 
                onClick={() => setShowLawEnforcement(true)}
                className="bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-semibold px-6 py-2 rounded-lg transition-all duration-200"
              >
                Law Enforcement Settings
              </button>
            </div>
          </div>
        </div>

        {/* Law Enforcement Form */}
        {showLawEnforcement && (
          <div className="mb-8">
            <LawEnforcementForm onClose={() => setShowLawEnforcement(false)} />
          </div>
        )}

        {/* Email Form */}
        <div className="bg-gray-800 rounded-xl p-6 border border-gray-700">
          <h2 className="text-xl font-semibold text-white mb-6">Send Email</h2>

          <div className="space-y-6">
            {/* Salutation */}
            <div>
              <select
                value={emailData.salutation}
                onChange={(e) => setEmailData({ ...emailData, salutation: e.target.value })}
                className="w-full bg-gray-700 border border-gray-600 rounded-lg px-4 py-3 text-white focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent"
              >
                {salutationOptions.map(option => (
                  <option key={option} value={option}>{option}</option>
                ))}
              </select>
            </div>

            {/* Last Name */}
            <div>
              <input
                type="text"
                placeholder="Last Name"
                value={emailData.lastName}
                onChange={(e) => setEmailData({ ...emailData, lastName: e.target.value })}
                className="w-full bg-gray-700 border border-gray-600 rounded-lg px-4 py-3 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent"
              />
            </div>

            {/* Email */}
            <div>
              <input
                type="email"
                placeholder="Email"
                value={emailData.email}
                onChange={(e) => setEmailData({ ...emailData, email: e.target.value })}
                className="w-full bg-gray-700 border border-gray-600 rounded-lg px-4 py-3 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent"
              />
            </div>

            {/* Your Name */}
            <div>
              <input
                type="text"
                placeholder="Your Name"
                value={emailData.yourName}
                onChange={(e) => setEmailData({ ...emailData, yourName: e.target.value })}
                className="w-full bg-gray-700 border border-gray-600 rounded-lg px-4 py-3 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent"
              />
            </div>

            {/* Email Type Selection */}
            <div className="flex space-x-4">
              <label className="flex items-center space-x-2 cursor-pointer">
                <input
                  type="radio"
                  name="emailType"
                  value="rescheduling"
                  checked={emailType === 'rescheduling'}
                  onChange={(e) => setEmailType(e.target.value)}
                  className="form-radio h-4 w-4 text-purple-600 focus:ring-purple-500 focus:ring-offset-gray-800"
                />
                <span className="text-white">Rescheduling Jury</span>
              </label>
              
              <label className="flex items-center space-x-2 cursor-pointer">
                <input
                  type="radio"
                  name="emailType"
                  value="custom"
                  checked={emailType === 'custom'}
                  onChange={(e) => setEmailType(e.target.value)}
                  className="form-radio h-4 w-4 text-purple-600 focus:ring-purple-500 focus:ring-offset-gray-800"
                />
                <span className="text-white">Custom Email</span>
              </label>
            </div>

            {/* Custom Message (only if custom email selected) */}
            {emailType === 'custom' && (
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">
                  Custom Message
                </label>
                <textarea
                  placeholder="Write your custom message here..."
                  value={emailData.customMessage}
                  onChange={(e) => setEmailData({ ...emailData, customMessage: e.target.value })}
                  rows={6}
                  className="w-full bg-gray-700 border border-gray-600 rounded-lg px-4 py-3 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                />
              </div>
            )}

            {/* Attachments */}
            <div>
              <label className="block text-sm font-medium text-gray-300 mb-2">
                Attachments
              </label>
              
              <div className="border-2 border-dashed border-gray-600 rounded-lg p-6 text-center">
                <input
                  type="file"
                  multiple
                  onChange={handleFileAttachment}
                  className="hidden"
                  id="file-upload"
                />
                <label
                  htmlFor="file-upload"
                  className="cursor-pointer flex flex-col items-center space-y-2"
                >
                  <PaperClipIcon className="h-8 w-8 text-gray-400" />
                  <span className="text-gray-400">Choose files or drag and drop</span>
                  <span className="text-sm text-gray-500">No files selected</span>
                </label>
              </div>

              {/* Attachment List */}
              {attachments.length > 0 && (
                <div className="mt-4 space-y-2">
                  {attachments.map((attachment) => (
                    <div key={attachment.id} className="flex items-center justify-between bg-gray-700 rounded-lg p-3">
                      <div className="flex items-center space-x-3">
                        <DocumentIcon className="h-5 w-5 text-gray-400" />
                        <div>
                          <p className="text-white text-sm font-medium">{attachment.name}</p>
                          <p className="text-gray-400 text-xs">{formatFileSize(attachment.size)}</p>
                        </div>
                      </div>
                      <button
                        onClick={() => removeAttachment(attachment.id)}
                        className="text-red-400 hover:text-red-300 transition-colors"
                      >
                        <XMarkIcon className="h-5 w-5" />
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Send Button */}
            <button
              onClick={handleSendEmail}
              className="w-full bg-gradient-to-r from-purple-600 to-purple-700 hover:from-purple-700 hover:to-purple-800 text-white font-semibold py-3 px-4 rounded-lg transition-all duration-200 flex items-center justify-center space-x-2"
            >
              <PaperAirplaneIcon className="h-5 w-5" />
              <span>Send Email</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const EnhancedEmailSystem = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex h-screen bg-gray-900">
        <MainContent>
          <EnhancedEmailComponent />
        </MainContent>
      
    </div>
  );
};

export default EnhancedEmailSystem;